export const Salutation = {
  Sir: 0,
  Madam: 1,
  Company: -1
}
